<template>
  <div class="index">
    <!-- 顶部横幅 -->
    <div class="banner">
      <div class="banner-overlay">
        <div class="banner-content">
          <h1>探索世界 发现美好</h1>
          <p>北京邑维智能科技有限公司</p>
        </div>
      </div>
      <img src="/imgs/banner.jpg" alt="旅游风景">
    </div>

    <div class="container">
      <!-- 今日要闻区块 -->
      <div class="news-section">
        <!-- 左侧大图区 -->
        <div class="featured-news">
          <div class="main-feature">
            <div class="feature-image">
              <img src="/imgs/n1.jpg" alt="特色旅游">
              <div class="feature-overlay">
                <h3>精选目的地</h3>
                <p>发现世界最美角落</p>
              </div>
            </div>
          </div>

          <div class="sub-features">
            <div class="sub-feature" v-for="(item, index) in ac" :key="index" @click="gopay(item.id)">
              <div class="sub-image">
                <img :src="item.img" :alt="item.title">
                <div class="sub-overlay">
                  <span>{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧今日要闻 -->
        <div class="today-news">
          <div class="section-header">
            <div class="header-main">
              <h2>今日要闻</h2>
              <span class="header-en">TODAY NEWS</span>
            </div>
            <div class="header-decoration"></div>
          </div>

          <div class="news-list">
            <div class="news-item" v-for="(item, index) in ac1" :key="index" @click="gopay()">
              <div class="news-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.jj }}</p>
              </div>
              <div class="news-meta">
                <span class="read-more">阅读更多</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 热门资讯区块 -->
      <div class="hot-news-section">
        <div class="section-header">
          <div class="header-main">
            <h2>热门资讯</h2>
            <span class="header-en">POPULAR NEWS</span>
          </div>
          <div class="header-decoration"></div>
        </div>

        <div class="hot-news-grid">
          <div class="hot-news-item" v-for="(item, index) in this.d1" :key="index" @click="gopay(item.id)">
            <div class="news-image">
              <img :src="item.img" :alt="item.title">
              <div class="image-overlay"></div>
            </div>
            <div class="news-info">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc">{{ item.jj }}</p>
              <div class="news-meta">
                <div class="author-info">
                  <span class="author">{{ item.author }}</span>
                  <span class="views">({{ item.sub }})阅读</span>
                </div>
                <div class="price-tag">
                  <span>阅读全文</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 付款弹窗 -->
    <modal title="请付款阅读" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <div class="payment-content">
          <img style="width: 275px" src="/imgs/pay.png" />
          <h2>扫码付费阅读：1元</h2>
          <p>解锁完整详细资讯</p>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
// import navigation from "./../components/navigation";
import Modal from "./../components/Modal.vue";
export default {
  components: { Modal },
  data() {
    return {
      href: "index.html",
      ac1: [],
      d1: [],
      ac3: [1, 2, 1, 1, 11, 1, 1],
      ac: [1, 2, 3],
      myData: [],
      mAc: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "北京邑维智能科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/ac.json").then((res) => {
        const data = res.data;
        this.ac = data.slice(0, 3);
        this.ac1 = data.slice(5, 7);
        this.d1 = data.slice(0, 10);
        this.ac2 = data.slice(5, 12);
        this.mAc = data.slice(4, 10);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      alert("资讯每条1元，点击确定购买");
      this.showModal = true;
    },
    // 登录跳转
    goLogin() {
      alert("资讯每篇1元，点击确定购买");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
// 修正颜色设置 - 使用HEX格式
$primary-color: #d4b896; // 原hsl(36.15deg 44.83% 65.88%)的近似HEX值
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.index {
  background: $background;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;

  // 横幅区域
  .banner {
    width: 100%;
    height: 500px;
    position: relative;
    overflow: hidden;
    margin-bottom: 60px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom,
          rgba(0, 0, 0, 0.2) 0%,
          rgba(0, 0, 0, 0.4) 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      .banner-content {
        text-align: center;
        color: white;
        max-width: 800px;
        padding: 0 20px;

        h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 20px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        p {
          font-size: 20px;
          opacity: 0.9;
          line-height: 1.6;
        }
      }
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  // 今日要闻区块
  .news-section {
    display: flex;
    gap: 40px;
    margin-bottom: 80px;

    // 左侧特色新闻
    .featured-news {
      flex: 7;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .main-feature {
        .feature-image {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;

          &:hover {
            transform: translateY(-5px);
          }

          img {
            width: 100%;
            height: 300px;
            object-fit: cover;
          }

          .feature-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(to top,
                rgba(0, 0, 0, 0.8) 0%,
                transparent 100%);
            color: white;
            padding: 30px 20px 20px;

            h3 {
              font-size: 24px;
              margin-bottom: 8px;
              font-weight: 600;
            }

            p {
              font-size: 16px;
              opacity: 0.9;
            }
          }
        }
      }

      .sub-features {
        display: flex;
        gap: 20px;

        .sub-feature {
          flex: 1;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          cursor: pointer;

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);

            .sub-overlay {
              background: rgba(212, 184, 150, 0.9);
            }
          }

          .sub-image {
            position: relative;
            height: 150px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .sub-overlay {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              align-items: center;
              justify-content: center;
              transition: background 0.3s ease;

              span {
                color: white;
                font-weight: 600;
                font-size: 14px;
                text-align: center;
                padding: 0 10px;
              }
            }
          }
        }
      }
    }

    // 右侧今日要闻
    .today-news {
      flex: 3;

      .section-header {
        margin-bottom: 30px;

        .header-main {
          display: flex;
          align-items: flex-end;
          margin-bottom: 10px;

          h2 {
            font-size: 28px;
            color: $text-dark;
            font-weight: 700;
            margin-right: 12px;
          }

          .header-en {
            font-size: 14px;
            color: $primary-color;
            font-weight: 600;
            margin-bottom: 4px;
          }
        }

        .header-decoration {
          height: 3px;
          width: 60px;
          background: linear-gradient(90deg, $primary-color, $accent-color);
          border-radius: 2px;
        }
      }

      .news-list {
        .news-item {
          background: $card-bg;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 20px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          cursor: pointer;

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);

            .news-content h3 {
              color: $primary-color;
            }

            .read-more {
              color: $primary-color;
            }
          }

          .news-content {
            h3 {
              font-size: 18px;
              color: $text-dark;
              margin-bottom: 12px;
              line-height: 1.4;
              transition: color 0.3s ease;
            }

            p {
              font-size: 14px;
              color: $text-light;
              line-height: 1.6;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }

          .news-meta {
            margin-top: 15px;
            display: flex;
            justify-content: flex-end;

            .read-more {
              font-size: 14px;
              color: $accent-color;
              font-weight: 600;
              transition: color 0.3s ease;
            }
          }
        }
      }
    }
  }

  // 热门资讯区块
  .hot-news-section {
    margin-bottom: 80px;

    .section-header {
      margin-bottom: 40px;

      .header-main {
        display: flex;
        align-items: flex-end;
        margin-bottom: 10px;

        h2 {
          font-size: 32px;
          color: $text-dark;
          font-weight: 700;
          margin-right: 12px;
        }

        .header-en {
          font-size: 16px;
          color: $primary-color;
          font-weight: 600;
          margin-bottom: 4px;
        }
      }

      .header-decoration {
        height: 4px;
        width: 80px;
        background: linear-gradient(90deg, $primary-color, $accent-color);
        border-radius: 2px;
      }
    }

    .hot-news-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;

      .hot-news-item {
        background: $card-bg;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);

          .news-image .image-overlay {
            opacity: 0.2;
          }

          .news-title {
            color: $primary-color;
          }
        }

        .news-image {
          position: relative;
          height: 200px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
          }

          .image-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: $primary-color;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
        }

        .news-info {
          padding: 20px;

          .news-title {
            font-size: 18px;
            color: $text-dark;
            margin-bottom: 12px;
            line-height: 1.4;
            transition: color 0.3s ease;
          }

          .news-desc {
            font-size: 14px;
            color: $text-light;
            line-height: 1.6;
            margin-bottom: 15px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .news-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .author-info {
              .author {
                font-size: 14px;
                color: $text-dark;
                font-weight: 600;
              }

              .views {
                font-size: 13px;
                color: $text-light;
                margin-left: 8px;
              }
            }

            .price-tag {
              span {
                font-size: 14px;
                color: $accent-color;
                font-weight: 600;
                padding: 6px 12px;
                background: rgba(90, 143, 180, 0.1);
                border-radius: 20px;
                transition: all 0.3s ease;

                &:hover {
                  background: $accent-color;
                  color: white;
                }
              }
            }
          }
        }
      }
    }
  }

  // 付款弹窗内容
  .payment-content {
    text-align: center;
    padding: 20px;

    h2 {
      color: $text-dark;
      margin: 20px 0 10px;
    }

    p {
      color: $text-light;
      font-size: 14px;
    }
  }
}

// 响应式调整（虽然不需要移动端，但确保在大屏上显示良好）
@media (max-width: 1200px) {
  .index .container {
    padding: 0 30px;
  }

  .news-section {
    flex-direction: column;

    .featured-news {
      .sub-features {
        .sub-feature {
          .sub-image {
            height: 200px;
          }
        }
      }
    }
  }

  .hot-news-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>